export default __webpack_public_path__ + "static/media/2FABFC69-378D-4588-952A-01B06D49619F.056c99c3.jpeg";